import React, { useEffect }  from 'react'

import { actionCreators, GettyActionCreators } from 'domains/org/getty/actions'
import { GettyStore, GettyAppState } from 'domains/org/getty/store'
import { SectionHeader } from 'components/ui/section-header'
import { StatusGuard } from 'components/ui/status-guard'

import { connect } from 'containers/store'

import { pick, pluralise } from 'helpers/core'
import { statusSelector } from 'helpers/status'

type ActionProps = Pick<GettyActionCreators, 'gettyListGetty360EventsRequest' >;

type ConnectedProps = Pick<GettyAppState, 'events' >;
type DirectProps = {
  projectId: string;
  historyPush: (id: string) => void;
  listItem: any;
};
type Props = ActionProps & ConnectedProps & DirectProps;

const SearchEventsView = (props: Props) => {
  const {
    gettyListGetty360EventsRequest,
    historyPush,
    projectId,
    listItem,
  } = props

  const ListItem = listItem;

  const data = statusSelector.data(props.events)

  useEffect(() => {
    gettyListGetty360EventsRequest()
  }, [gettyListGetty360EventsRequest]) // eslint-disable-line react-hooks/exhaustive-deps

  const events = data ? data.getty360Events : [];
  const eventsCount = events ? events.length : 0;

  return (
    <>
      <StatusGuard status={props.events}>
        <SectionHeader heading={`${eventsCount} ${pluralise(eventsCount, "event", "events")}`} />
        {events && events.map(event => <ListItem key={event.eventId} historyPush={historyPush} projectId={projectId} event={event} />)}
      </StatusGuard>
    </>
  )
};

export const SearchEvents = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => ({
    ...pick(store.getty, 'events'),
  }),
  {
    ...pick(actionCreators, 'gettyListGetty360EventsRequest'),
  }
)(SearchEventsView)
